import { useFormik } from 'formik'
import {
  useUpdateProjectWikiLinkMutation,
  useUpdateProjectGanttLinkMutation,
} from 'apiv2/projects'
import { GANTT_STATUS } from './constants'
import { validationSchema } from './validationSchema'

export const useUpdateWikiLink = (initialValue, slug) => {
  const [updateWikiLink, { isLoading }] = useUpdateProjectWikiLinkMutation()

  const formik = useFormik({
    initialValues: {
      link: initialValue ?? '',
    },
    validationSchema: validationSchema(),
    onSubmit: async (values) => {
      await updateWikiLink({
        slug: slug,
        data: {
          wiki_link: values.link.trim(),
        },
      }).unwrap()
    },
  })

  return { formik, isLoading }
}

export const useUpdateGanttLink = (initialValue, slug) => {
  const [updateProjectGanttLink, { isLoading }] =
    useUpdateProjectGanttLinkMutation()

  const formik = useFormik({
    initialValues: {
      link: initialValue?.link ?? '',
      isProtected: initialValue?.status === GANTT_STATUS.PROTECTED,
    },
    validationSchema: validationSchema({ requireGanttProPrefix: true }),
    onSubmit: async (values) => {
      await updateProjectGanttLink({
        slug: slug,
        data: {
          ganttpro_link: values.link.trim(),
          ganttpro_is_pwd_protected: values.isProtected,
        },
      }).unwrap()
    },
  })

  return { formik, isLoading }
}
